
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30810',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30810",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55347",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8353",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11811",
  "I18n": "static-7.1677",
  "quartz": "static-1.7481",
  "quartz-config": "static-1.1259",
  "quartz-core": "static-1.6700",
  "react-dlb": "static-1.89",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.80",
  "reselect": "static-3.12",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.943",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55334",
  "feedback-utils": "static-1.55338",
  "forms-embed-utils-lib": "static-1.4787",
  "forms-utils-lib": "static-1.13116",
  "foundations-assets": "static-1.5206",
  "foundations-components": "static-1.8518",
  "foundations-theming": "static-1.4796",
  "hub-http": "static-1.6536",
  "hubspot-url-utils": "static-1.4297",
  "HubStyle": "static-2.12118",
  "icons": "static-2.686",
  "immutable": "static-2.83",
  "quick-fetch": "static-1.4144",
  "raven": "static-3.5925",
  "react": "static-7.196",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1.17042",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5571",
  "react-virtualized": "static-2.107",
  "redux": "static-4.76",
  "StyleGuideUI": "static-3.504",
  "tinymce-plugins": "static-1.58250",
  "transmute": "static-2.97",
  "ui-images": "static-2.1254",
  "UIComponents": "static-3.8757",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3758",
  "quartz-webpack": "static-1.3705",
  "foundations-theming-specialty": "static-1.2512",
  "property-description-translator": "static-1.4160",
  "HeadJS": "static-2.799",
  "framer-motion": "static-1.79",
  "hs-test-utils-bend-plugin": "static-1.3464",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4634",
  "jasmine-runner": "static-1.6772",
  "opentelemetry-fe-types": "static-1.96",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.885",
  "hubspotter-http": "static-1.4878",
  "mobile-manifest-mixins": "static-1.579",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.471",
  "quartz-auth": "static-1.1156",
  "quartz-head": "static-1.1146",
  "quartz-i18n": "static-1.1156",
  "quartz-routing": "static-1.911",
  "quartz-test": "static-1.1156",
  "quartz-tracking": "static-1.860",
  "trellis-components": "static-1.2708",
  "ui-fonts": "static-1.1073",
  "usage-tracker-container": "static-1.7627",
  "usage-tracker-core": "static-1.7487",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.212",
  "conversations-skeleton-state": "static-1.7570",
  "reference-resolvers": "static-1.8503",
  "sanitize-text": "static-1.8479",
  "PatternValidationJS": "static-1.3214",
  "ReduxMessenger": "static-2.10692",
  "outpost": "static-1.4475",
  "rpc-client-utils": "static-1.4988",
  "sanitize": "static-1.4794",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4787",
  "floating-ui": "static-1.63",
  "hs-story-utils": "static-1.9747",
  "react-aria": "static-1.72",
  "react-create-root-preference": "static-1.74",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2689",
  "bend-plugin-foundations-theming": "static-1.3279",
  "foundations-theming-base": "static-1.3781",
  "stylex": "static-1.41",
  "hs-locale-management": "static-1.310",
  "csstype": "static-1.50",
  "web-vitals": "static-1.15",
  "ai-components-ui-library": "static-1.9755",
  "atom": "static-1.5408",
  "codemirror": "static-5.102",
  "content-assistance-lib": "static-1.8222",
  "ContentUtils": "static-1.69155",
  "data-token-picker": "static-1.16913",
  "file-manager-components": "static-1.24539",
  "FileManagerCore": "static-1.40038",
  "FileManagerLib": "static-1.40179",
  "frontend-preferences-client": "static-1.8243",
  "hub-http-contrib": "static-1.3361",
  "interframe": "static-3.5076",
  "layout-dnd-components": "static-1.12995",
  "layout-dnd-utils": "static-1.11970",
  "property-translator": "static-1.5717",
  "react-codemirror": "static-1.10964",
  "react-colorpicker": "static-2.10538",
  "reference-resolvers-lite": "static-1.8426",
  "rich-text-lib": "static-1.20329",
  "tinymce-data": "static-1.41221",
  "tinymce-themes": "static-1.57106",
  "ui-addon-emoji-picker": "static-1.10207",
  "ui-addon-sales-email": "static-1.5537",
  "ui-brand-identity-lib": "static-1.16551",
  "bender-build-tools": "static-1.3452",
  "opentelemetry-web": "static-1.15",
  "hub-http-shared-msw-handlers": "static-1.10647",
  "hubspotter-http-shared-msw-handlers": "static-1.10645",
  "usage-tracker-session-replay": "static-1.5323",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "trellis-theming": "static-1.1297",
  "tanstack-virtual": "static-1.38",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.398",
  "chirp-fetch": "static-1.2217",
  "stylex-utils": "static-1.145",
  "chatspot-core": "static-1.23107",
  "copilot-toolkit": "static-1.11872",
  "customer-data-objects-ui-components": "static-1.13353",
  "data-fetching-client": "static-1.9977",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5079",
  "ui-addon-video-player": "static-1.9026",
  "ui-coaching-tips": "static-1.29338",
  "usage-tracker": "static-1.7637",
  "cms-field-types": "static-1.5136",
  "content-icons-ui": "static-1.2386",
  "integrations-lib": "static-1.17075",
  "customer-data-objects": "static-1.8016",
  "breeze-engine-lib": "static-1.1784",
  "immer": "static-1.101",
  "immerable": "static-1.4471",
  "ui-addon-iframeable": "static-1.9398",
  "video-components-external": "static-1.12175",
  "video-data-lib": "static-1.35833",
  "breeze-artifacts-sdk": "static-1.403",
  "audio-components": "static-1.6368",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29835",
  "FileManagerImages": "static-1.37690",
  "html-to-image": "static-1.61",
  "redux-toolkit": "static-1.78",
  "ui-universal-auth": "static-1.9431",
  "urlinator": "static-1.4855",
  "video-components": "static-1.14177",
  "video-embed": "static-1.36667",
  "ts-schema": "static-1.4309",
  "ContentData": "static-1.69230",
  "layout-data-lib": "static-1.10295",
  "react-dnd-compat": "static-1.4938",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1866",
  "external-options-client-types": "static-1.4355",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7214",
  "hs-promise-utils": "static-1.5916",
  "inbound-db-properties-service-client": "static-1.4066",
  "NamespacedHubStyle": "static-2.9281",
  "apollo-dlb": "static-3.86",
  "apollo-stack-hubspot": "static-3.94",
  "graphql": "static-1.89",
  "growth-onboarding-confetti": "static-1.3384",
  "SharedI18nStrings": "static-1.183",
  "ui-addon-i18n": "static-1.11468",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5773",
  "magpie-types": "static-1.5233",
  "simple-logging-lib": "static-1.3373",
  "avatar-components": "static-1.2804",
  "customer-data-ui-utilities": "static-1.10154",
  "growth-onboarding-feedback-components": "static-1.6906",
  "flux-actions": "static-1.370",
  "hubspot-apollo-client": "static-1.5197",
  "integrations-error-boundary-lib": "static-1.14490",
  "integrations-tracking-lib": "static-1.5931",
  "laboratory-lib": "static-3.7475",
  "native-integrations-shared-strings": "static-1.8099",
  "redux-observable": "static-1.75",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10591",
  "unified-auth": "static-1.945",
  "breeze-engine-chat-components": "static-1.762",
  "breeze-engine-core": "static-1.1062",
  "ably": "static-2.2",
  "highlight.js": "static-1.86",
  "navigation-messaging": "static-1.8191",
  "apollo-link-hub-http": "static-2.4978",
  "content-media-composition-data-lib": "static-1.13274",
  "content-media-compositions": "static-2.17281",
  "idb-keyval": "static-1.51",
  "media-bridge-lib": "static-1.19427",
  "foundations-components-legacy": "static-1.1543",
  "unified-auth-core-lib": "static-1.1227",
  "social-insights-client-types": "static-1.22706",
  "advanced-menus-core": "static-1.15599",
  "advanced-menus-lib": "static-1.12473",
  "ExportDialog": "static-6.10700",
  "ui-memberships-settings-lib": "static-1.34875",
  "conditional-properties-service-client": "static-1.4031",
  "crm-pipelines-api-client-types": "static-1.4363",
  "fdsr-migration-layer": "static-1.333",
  "framework-builder-read-service-client": "static-1.4237",
  "framework-data-schema-quick-fetch": "static-1.7119",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3924",
  "persist-promise": "static-1.4023",
  "foundations-components-test-utils": "static-1.6001",
  "reactive-lib": "static-1.1040",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.656",
  "universal-page-editor-lib": "static-1.3332",
  "adobe-sign-auth-lib": "static-1.495",
  "ads-unified-auth-lib": "static-1.1455",
  "generic-oauth-auth-lib": "static-1.73",
  "google-sheets-integration-lib": "static-1.1060",
  "microsoft-drive-auth-lib": "static-1.176",
  "surveymonkey-integration-lib": "static-1.518",
  "slack-ui-library": "static-1.10720",
  "js-cookie": "static-1.18",
  "fsm": "static-1.4073",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15598",
  "simple-menus-lib": "static-1.17115",
  "settings-ui-lib": "static-1.12846",
  "crm-record-cards-service-types": "static-1.3796",
  "location-customization-utils-lib": "static-1.10131",
  "react-flip-move": "static-1.78"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30810",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55347",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8353",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11811",
  "I18n": "/I18n/static-7.1677",
  "quartz": "/quartz/static-1.7481",
  "quartz-config": "/quartz-config/static-1.1259",
  "quartz-core": "/quartz-core/static-1.6700",
  "react-dlb": "/react-dlb/static-1.89",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.80",
  "reselect": "/reselect/static-3.12",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.943",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55334",
  "feedback-utils": "/feedback-utils/static-1.55338",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4787",
  "forms-utils-lib": "/forms-utils-lib/static-1.13116",
  "foundations-assets": "/foundations-assets/static-1.5206",
  "foundations-components": "/foundations-components/static-1.8518",
  "foundations-theming": "/foundations-theming/static-1.4796",
  "hub-http": "/hub-http/static-1.6536",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyle": "/HubStyle/static-2.12118",
  "icons": "/icons/static-2.686",
  "immutable": "/immutable/static-2.83",
  "quick-fetch": "/quick-fetch/static-1.4144",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.196",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1.17042",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5571",
  "react-virtualized": "/react-virtualized/static-2.107",
  "redux": "/redux/static-4.76",
  "StyleGuideUI": "/StyleGuideUI/static-3.504",
  "tinymce-plugins": "/tinymce-plugins/static-1.58250",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1254",
  "UIComponents": "/UIComponents/static-3.8757",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3758",
  "quartz-webpack": "/quartz-webpack/static-1.3705",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2512",
  "property-description-translator": "/property-description-translator/static-1.4160",
  "HeadJS": "/HeadJS/static-2.799",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3464",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4634",
  "jasmine-runner": "/jasmine-runner/static-1.6772",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.96",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.885",
  "hubspotter-http": "/hubspotter-http/static-1.4878",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.579",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.471",
  "quartz-auth": "/quartz-auth/static-1.1156",
  "quartz-head": "/quartz-head/static-1.1146",
  "quartz-i18n": "/quartz-i18n/static-1.1156",
  "quartz-routing": "/quartz-routing/static-1.911",
  "quartz-test": "/quartz-test/static-1.1156",
  "quartz-tracking": "/quartz-tracking/static-1.860",
  "trellis-components": "/trellis-components/static-1.2708",
  "ui-fonts": "/ui-fonts/static-1.1073",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.212",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7570",
  "reference-resolvers": "/reference-resolvers/static-1.8503",
  "sanitize-text": "/sanitize-text/static-1.8479",
  "PatternValidationJS": "/PatternValidationJS/static-1.3214",
  "ReduxMessenger": "/ReduxMessenger/static-2.10692",
  "outpost": "/outpost/static-1.4475",
  "rpc-client-utils": "/rpc-client-utils/static-1.4988",
  "sanitize": "/sanitize/static-1.4794",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4787",
  "floating-ui": "/floating-ui/static-1.63",
  "hs-story-utils": "/hs-story-utils/static-1.9747",
  "react-aria": "/react-aria/static-1.72",
  "react-create-root-preference": "/react-create-root-preference/static-1.74",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2689",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3279",
  "foundations-theming-base": "/foundations-theming-base/static-1.3781",
  "stylex": "/stylex/static-1.41",
  "hs-locale-management": "/hs-locale-management/static-1.310",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.15",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9755",
  "atom": "/atom/static-1.5408",
  "codemirror": "/codemirror/static-5.102",
  "content-assistance-lib": "/content-assistance-lib/static-1.8222",
  "ContentUtils": "/ContentUtils/static-1.69155",
  "data-token-picker": "/data-token-picker/static-1.16913",
  "file-manager-components": "/file-manager-components/static-1.24539",
  "FileManagerCore": "/FileManagerCore/static-1.40038",
  "FileManagerLib": "/FileManagerLib/static-1.40179",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8243",
  "hub-http-contrib": "/hub-http-contrib/static-1.3361",
  "interframe": "/interframe/static-3.5076",
  "layout-dnd-components": "/layout-dnd-components/static-1.12995",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11970",
  "property-translator": "/property-translator/static-1.5717",
  "react-codemirror": "/react-codemirror/static-1.10964",
  "react-colorpicker": "/react-colorpicker/static-2.10538",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8426",
  "rich-text-lib": "/rich-text-lib/static-1.20329",
  "tinymce-data": "/tinymce-data/static-1.41221",
  "tinymce-themes": "/tinymce-themes/static-1.57106",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10207",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5537",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16551",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10647",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10645",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "trellis-theming": "/trellis-theming/static-1.1297",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.398",
  "chirp-fetch": "/chirp-fetch/static-1.2217",
  "stylex-utils": "/stylex-utils/static-1.145",
  "chatspot-core": "/chatspot-core/static-1.23107",
  "copilot-toolkit": "/copilot-toolkit/static-1.11872",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13353",
  "data-fetching-client": "/data-fetching-client/static-1.9977",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5079",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9026",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29338",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "cms-field-types": "/cms-field-types/static-1.5136",
  "content-icons-ui": "/content-icons-ui/static-1.2386",
  "integrations-lib": "/integrations-lib/static-1.17075",
  "customer-data-objects": "/customer-data-objects/static-1.8016",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1784",
  "immer": "/immer/static-1.101",
  "immerable": "/immerable/static-1.4471",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9398",
  "video-components-external": "/video-components-external/static-1.12175",
  "video-data-lib": "/video-data-lib/static-1.35833",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.403",
  "audio-components": "/audio-components/static-1.6368",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29835",
  "FileManagerImages": "/FileManagerImages/static-1.37690",
  "html-to-image": "/html-to-image/static-1.61",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "ui-universal-auth": "/ui-universal-auth/static-1.9431",
  "urlinator": "/urlinator/static-1.4855",
  "video-components": "/video-components/static-1.14177",
  "video-embed": "/video-embed/static-1.36667",
  "ts-schema": "/ts-schema/static-1.4309",
  "ContentData": "/ContentData/static-1.69230",
  "layout-data-lib": "/layout-data-lib/static-1.10295",
  "react-dnd-compat": "/react-dnd-compat/static-1.4938",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1866",
  "external-options-client-types": "/external-options-client-types/static-1.4355",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7214",
  "hs-promise-utils": "/hs-promise-utils/static-1.5916",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4066",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9281",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "graphql": "/graphql/static-1.89",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3384",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11468",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5773",
  "magpie-types": "/magpie-types/static-1.5233",
  "simple-logging-lib": "/simple-logging-lib/static-1.3373",
  "avatar-components": "/avatar-components/static-1.2804",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10154",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6906",
  "flux-actions": "/flux-actions/static-1.370",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5197",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14490",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5931",
  "laboratory-lib": "/laboratory-lib/static-3.7475",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8099",
  "redux-observable": "/redux-observable/static-1.75",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10591",
  "unified-auth": "/unified-auth/static-1.945",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.762",
  "breeze-engine-core": "/breeze-engine-core/static-1.1062",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.86",
  "navigation-messaging": "/navigation-messaging/static-1.8191",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4978",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13274",
  "content-media-compositions": "/content-media-compositions/static-2.17281",
  "idb-keyval": "/idb-keyval/static-1.51",
  "media-bridge-lib": "/media-bridge-lib/static-1.19427",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1543",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1227",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "advanced-menus-core": "/advanced-menus-core/static-1.15599",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12473",
  "ExportDialog": "/ExportDialog/static-6.10700",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34875",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4031",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4363",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.333",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4237",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7119",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3924",
  "persist-promise": "/persist-promise/static-1.4023",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6001",
  "reactive-lib": "/reactive-lib/static-1.1040",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.656",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3332",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.495",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1455",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.73",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1060",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.176",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.518",
  "slack-ui-library": "/slack-ui-library/static-1.10720",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.4073",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15598",
  "simple-menus-lib": "/simple-menus-lib/static-1.17115",
  "settings-ui-lib": "/settings-ui-lib/static-1.12846",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3796",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10131",
  "react-flip-move": "/react-flip-move/static-1.78"
}
};
